export const DepartmentRoutes = {
    GetDepartment: "department",
    DeleteDepartment: "department/delete",
    SaveDepartment: "department/save",
    CloneDepartment: "department/clone",
    ChangeActivationState: "department/ChangeDepartmentActivationState"
}